import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '../../../core/services/general.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  message: any;
  type: any;
  actions: any;
  link: string = ''


  constructor(private GS: GeneralService, private router:Router) {}
  ngOnInit(): void {
    this.GS.currentNote.subscribe((note) => {
      if (!note) {
        this.message = '';
      } else {
        this.message = note.text;
        this.type = note.type;
        this.actions = note.actions;
        if (note.link!=''){
          this.link = note.link;
        }
        setTimeout(() => {
          this.message = '';
        }, note.duration);
      }
    });
  }

  hideNote() {
    this.GS.sendNote({});
  }

  navigateToFilter(){
    localStorage.setItem('customFilterActionPage', 'create');
    console.log("saving custom report")
    localStorage.setItem('reportType', 'Custom Date');
    this.router.navigate([this.link]);
  }
}
